import ICON_WALLET from 'Icon/MenuProfile/icon-wallet.png';
import ICON_WALLET_INACTIVE from 'Icon/rdn/v2/inactive/icon-wallet-gray.png';

export const PAGE = {
  RDN: 'RDN',
};

export const MENU = {
  TOPUP: 'topup',
  WITHDRAW: 'withdraw',
  SETTLEMENT: 'settlement',
  HISTORY: 'history',
};

export const RDN_TAB_PAGE = [
  {
    name: 'Saldo RDN',
    key: PAGE.RDN,
    component: null,
    icon: ICON_WALLET,
    inactiveIcon: ICON_WALLET_INACTIVE,
  },
];
